<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-table-presupuesto-gestion"
      :columnDefs="columnDefs"
      :defaultColDef="{ ...defaultColDef, floatingFilter: false }"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :pinnedBottomRowData="pinnedBottomRowData"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>

<script>
import { aMonedaValueFormatter, cellRendererNumeroRegistro, ESTADOS_DETALLE_TRANSACCION } from '../utils';
import ListadoAgGridMixin from '../mixins/listado-ag-grid-mixin';

export default {
  name: 'ListadoPresupuestoGestion',
  mixins: [ListadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'NRO. REG.',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'MES',
          field: 'mes',
          filter: false,
          minWidth: 140,
        },
        {
          headerName: 'TOTAL',
          field: 'total',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'FECHA CREACION',
          field: 'created_at',
          filter: false,
          minWidth: 150,
        },
        {
          headerName: 'ESTADO',
          cellRenderer: function (params) {
            if (params.node.rowPinned) {
              return undefined;
            } else {
              const transacciones = params.data.detalles_transacciones;
              const estadoPendiente = ESTADOS_DETALLE_TRANSACCION.PENDIENTE;
              const estadoAceptado = ESTADOS_DETALLE_TRANSACCION.ACEPTADO;
              const estadoRechazado = ESTADOS_DETALLE_TRANSACCION.RECHAZADO;

              return transacciones.every((item) => item.estado == estadoPendiente)
                ? estadoPendiente.toUpperCase()
                : transacciones.some((item) => item.estado == estadoRechazado)
                ? estadoRechazado.toUpperCase()
                : transacciones.some((item) => item.estado == estadoPendiente)
                ? estadoPendiente.toUpperCase()
                : estadoAceptado.toUpperCase();
            }
          },
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
      ],
    };
  },
  computed: {
    pinnedBottomRowData() {
      return [
        {
          mes: 'TOTAL',
          total: this.calcularTotal(),
          bold: true,
        },
      ];
    },
  },
  created: function () {
    this.getRowStyle = (params) => {
      if (params.node.rowPinned) {
        if (params.node.data.bold) {
          return { 'font-weight': 'bold' };
        }
      }
    };
  },
  methods: {
    calcularTotal() {
      let resultado = 0;

      for (let index = 0; index < this.items.length; index++) {
        resultado = resultado + parseFloat(this.items[index].total);
      }

      return resultado.toFixed(2);
    },
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-table-presupuesto-gestion {
  height: calc(var(--vh, 1vh) * 100 - 20rem);
}
</style>
